import { Component, OnInit } from "@angular/core";
import { OperatingStandardService } from "../../services/operating-standard.service";
import { Router } from "@angular/router";
import { AdminService } from "../../services/admin.service";
import { StepsControllerService } from "../../services/steps-controller.service";
import { UserService } from "../../services/user.service";
import { NotificationsService } from "../../services/notifications.service";
import * as moment from "moment";
import { SidebarService } from "../../services/side-bar.service";
import { TaskBarService } from "../../services/task-bar.service";
import { FabMessageService } from "../../services/fab-message.service";
import { AuthService } from "../../services/auth.service";
import { ReportDatepickerComponent } from "../../modals/report-datepicker.component";
import { ReportType } from "../../models/report-type.model";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { User } from "../../models/user.model";
import {
  AppNotification,
  ClothingNotificationRoutingService
} from "../../services/clothing-notification-routing.service";
import { ClothingNotificationActionService } from "../../services/clothing-notification-action.service";
import { ClothingNotificationDisplayService } from "../../services/clothing-notification-display.service";

const STANDARD_NOTIFICATION_CATEGORY = "STANDARD";
const SUGGESTION_NOTIFICATION_CATEGORY = "SUGGESTION";
const GENERAL_NOTIFICATION_CATEGORY = "NOTIFICATION_GENERAL";
const SUGGESTION_NOTIFICATION_LIST_INDEX = 2;
const GENERAL_NOTIFICATION_LIST_INDEX = 3;
const CLOTHING_NOTIFICATION_LIST_INDEX = 4;
const NOTIFICATION_HISTORY_PAGE_SIZE = 15;
const MOBILE_NOTIFICATIONS_BREAKPOINT = 1050;

@Component({
  selector: "app-operating-standard",
  templateUrl: "./operating-standard.component.html",
  styleUrls: ["./operating-standard.component.css"]
})
export class OperatingStandardComponent implements OnInit {
  activeList = 1;
  requiredActionList: any = [];
  standardsList: any = [];
  suggestionLists: any = [];
  isLoaded = false;
  errorMessage = false;
  sortOrdersStnd: string[] = [];
  sortOrdersSuggest: string[] = [];
  displayingStandards: any = [];
  displayingSuggestions: any = [];
  displayingClothingNotifications: AppNotification[] = [];
  displayingStandardsViewed: any = [];
  displayingSuggestViewed: any = [];
  allGeneralNotifications: AppNotification[] = [];
  clothingNotifications: AppNotification[] = [];
  selectedSortOrderStnd = "ALL";
  selectedSortOrderSuggest = "ALL";
  sortedSuggestionsTable: any = [];
  sortOrder: any = null;
  currentSortField: string | null = null;
  generalNotify: AppNotification[] = [];
  notificationHistoryPageSize = NOTIFICATION_HISTORY_PAGE_SIZE;
  suggestionHistoryPage = 1;
  suggestionHistoryTotalItems = 0;
  suggestionHistoryLoaded = false;
  suggestionHistoryLoading = false;
  generalHistoryPage = 1;
  generalHistoryTotalItems = 0;
  generalHistoryLoaded = false;
  generalHistoryLoading = false;
  karma = false;
  show = false;
  title = 'Show all notifications'
  mobWidth: any;
  mainGroup: any;
  isAdmin = false;
	isUser = false;
	isHead = false;
  isStorekeeper = false;
  public user: User;
  allHeadGroups;

  constructor(
    private operatingStandardService: OperatingStandardService,
    private router: Router,
    private adminService: AdminService,
    private notificationsService: NotificationsService,
    public stepsControllerService: StepsControllerService,
    public userService: UserService,
    public sidebarService: SidebarService,
    public taskbarService: TaskBarService,
    public fabService: FabMessageService,
    public authService: AuthService,
    private modalService: NgbModal,
    private clothingNotificationRoutingService: ClothingNotificationRoutingService,
    private clothingNotificationActionService: ClothingNotificationActionService,
    private clothingNotificationDisplayService: ClothingNotificationDisplayService
  ) {

    this.mobWidth = window.innerWidth;

    const getWindow = () => {
      return window.innerWidth;
    };

    window.onresize = () => {
      this.mobWidth = getWindow();
      this.handleViewportResize();
    };
   }

  ngOnInit() {
   this.mainGroup = JSON.parse(localStorage.getItem('User')).mainGroup;
   this.user = this.userService.getLocal();
   this.isStorekeeper = this.hasStorekeeperRole(this.user);
   this.setPreferredActiveList();
    this.getGeneralNotify(this.userService.getLocal().id);
    this.isLoaded = false;
    this.errorMessage = false;
    this.operatingStandardService
      .getOperatingStandsNotificationsAPITemp()
      .subscribe(
        (res: any) => {
          if (res.status === 200) {
            const allNotificationLists = res.body;

            if (allNotificationLists.hasOwnProperty("GLOBAL")) {
              allNotificationLists.GLOBAL.forEach(gs => {
                this.requiredActionList.push(gs);
              });
            }

            if (allNotificationLists.hasOwnProperty("SUGGESTION")) {
              allNotificationLists.SUGGESTION.forEach(ss => {
                this.requiredActionList.push(ss);
              });
            }

            if (allNotificationLists.hasOwnProperty("SUGGESTION_ACTION")) {
              allNotificationLists.SUGGESTION_ACTION.forEach(sas => {
                this.requiredActionList.push(sas);
              });
            }

            if (allNotificationLists.hasOwnProperty("SUGGESTION_CANCEL")) {
              allNotificationLists.SUGGESTION_CANCEL.forEach(scs => {
                this.requiredActionList.push(scs);
              });
            }

            if (this.hasNotificationItems()) {
              this.sortNotifications();
            } else {
              this.isLoaded = true;
            }
          } else if (res.status === 204) {
            this.requiredActionList = [];
            this.standardsList = [];
            this.suggestionLists = [];
            this.isLoaded = true;
          }
        },
        () => {
          this.isLoaded = true;
          this.errorMessage = true;
          this.requiredActionList = [];
        }
      );
      if (this.user.roles.indexOf('ROLE_HEAD') !== -1) {
        this.isHead = true;
        this.getAllGroups();
      }
  }

  getAllGroups() {
    this.adminService.getGroupsAndPositionsHead().subscribe(
      (res: any) => {
        if (res.status === 200) {
          this.allHeadGroups = res.body;
        }
      }
    )
  }

  open(id) {
		const modalRef = this.modalService.open(ReportDatepickerComponent);
		modalRef.componentInstance.reportType = ReportType.BY_VACATION;
		modalRef.componentInstance.userId = id;
	}

  shoeList() {
    this.show = !this.show;
    this.title = this.show ? 'Hide read notifications' : 'Show all notifications';
    this.updateClothingNotifications();
    this.reloadActiveNotificationHistory();
  }

  signOut() {
    this.userService.writeLogoutTime().subscribe(
      (response: any) => {
        this.fabService.showFab(1);
      },
      (error: any) => {
        if (error.status === 400) {
          this.fabService.showFab(2);
        }
      }
    );
    this.authService.signOut();
  }

  disableLogout(): boolean {
    return this.userService.getLocal().testing;
  }

  recordSignOutTime() {
    this.userService.writeLogoutTime().subscribe(
      (response: any) => {
        this.fabService.showFab(1);
      },
      (error: any) => {
        if (error.status === 400) {
          this.fabService.showFab(2);
        }
      }
    );
  }

  getGeneralNotify(id) {
    this.operatingStandardService.getGeneralNoitify(id)
      .subscribe(
        (res: any) => {
          this.processGeneralNotifications(res.body);
        },
        () => {
          this.isLoaded = true;
          this.errorMessage = true;
          this.requiredActionList = [];
          if (!this.generalHistoryLoaded && !this.generalHistoryLoading) {
            this.generalNotify = [];
            this.karma = false;
          }
          this.allGeneralNotifications = [];
          this.clothingNotifications = [];
          this.updateClothingNotifications();
        }
      );

  }

  getDate(tmsp) {
    if (!tmsp) {
      return "";
    }
    return moment.utc(tmsp).format("DD/MM/YYYY");
  }

  isClothingNotification(notification: AppNotification): boolean {
    return this.clothingNotificationRoutingService.isClothingNotification(notification);
  }

  isViewedClothingNotification(notification: AppNotification): boolean {
    return this.isClothingNotification(notification) && !!notification.viewed;
  }

  resolveClothingNotificationText(notification: AppNotification): string {
    return this.clothingNotificationDisplayService.resolveText(notification);
  }

  hasGeneralNotificationDisplayText(notification: AppNotification): boolean {
    if (this.isClothingNotification(notification)) {
      return true;
    }
    return !!notification && !!notification.description && !!notification.description.length;
  }

  resolveGeneralNotificationText(notification: AppNotification): string {
    if (this.isClothingNotification(notification)) {
      return this.resolveClothingNotificationText(notification);
    }
    if (notification && notification.description) {
      return notification.description;
    }
    return '';
  }

  getNotificationDate(notification: AppNotification): string {
    if (notification && notification.timestamp) {
      return notification.timestamp;
    }
    return notification.create;
  }

  hasDisplayedClothingNotifications(): boolean {
    return !!this.displayingClothingNotifications.length;
  }

  getMobileStandards(): any[] {
    if (!this.show) {
      return this.displayingStandards;
    }
    return this.displayingStandards.concat(this.displayingStandardsViewed);
  }

  hasMobileStandards(): boolean {
    return !!this.getMobileStandards().length;
  }

  isMobileView(): boolean {
    return this.mobWidth <= MOBILE_NOTIFICATIONS_BREAKPOINT;
  }

  isStorekeeperMobileFlow(): boolean {
    return this.isStorekeeper && this.isMobileView();
  }

  showMobileClothingNotifications(): boolean {
    return this.isMobileView();
  }

  getMobileSuggestions(): any[] {
    return this.filterViewedNotifications(this.sortedSuggestionsTable);
  }

  hasDisplayedSuggestions(): boolean {
    return !!this.filterViewedNotifications(this.sortedSuggestionsTable).length;
  }

  hasMobileSuggestions(): boolean {
    return this.hasDisplayedSuggestions();
  }

  getMobileGeneralNotifications(): AppNotification[] {
    return this.filterViewedNotifications<AppNotification>(this.generalNotify);
  }

  hasDisplayedGeneralNotifications(): boolean {
    return !!this.filterViewedNotifications<AppNotification>(this.generalNotify).length;
  }

  hasMobileGeneralNotifications(): boolean {
    return this.hasDisplayedGeneralNotifications();
  }

  isNotificationHistoryLoading(): boolean {
    return this.suggestionHistoryLoading || this.generalHistoryLoading;
  }

  trackByNotificationId(index: number, notification: AppNotification): string | number {
    if (notification && notification.id) {
      return notification.id;
    }
    return index;
  }

  getSuggestionNotificationBadgeCount(): number {
    if (this.suggestionHistoryLoaded) {
      return this.suggestionHistoryTotalItems;
    }
    return this.suggestionLists.length;
  }

  getGeneralNotificationBadgeCount(): number {
    if (this.generalHistoryLoaded) {
      return this.generalHistoryTotalItems;
    }
    return this.generalNotify ? this.generalNotify.length : 0;
  }

  isPositiveKarmaDirection(notification: any): boolean {
    return notification && (notification.direction === "UP" || notification.direction === "PLUS");
  }

  isNegativeKarmaDirection(notification: any): boolean {
    return notification && (notification.direction === "DOWN" || notification.direction === "MINUS");
  }

  sortNotifications() {
    if (this.requiredActionList.length > 0) {
      this.requiredActionList.forEach(i => {
        if (i.hasOwnProperty("standardNumber") && i.status !== "INACTIVE") {
          this.standardsList.push(i);
        }
        if (i.hasOwnProperty("suggestionId") && i.status !== "INACTIVE") {
          this.suggestionLists.push(i);
        }
      });
      this.setDaysField(this.standardsList);
      this.setDaysField(this.suggestionLists);
      const sortStndParams = [];
      const sortSuggestParams = [];
      for (let i = 0; i < this.standardsList.length; i++) {
        sortStndParams.push(this.standardsList[i].type);
      }
      for (const str of sortStndParams) {
        if (!this.sortOrdersStnd.includes(str)) {
          this.sortOrdersStnd.push(str);
        }
      }
      for (let i = 0; i < this.suggestionLists.length; i++) {
        sortSuggestParams.push(this.suggestionLists[i].type);
      }
      for (const str of sortSuggestParams) {
        if (!this.sortOrdersSuggest.includes(str)) {
          this.sortOrdersSuggest.push(str);
        }
      }
      this.displayingStandards = this.standardsList;
      this.displayingSuggestions = this.suggestionLists;
      this.isLoaded = true;
    }
    this.displayingStandards.reverse();
    this.displayingSuggestions.reverse();

    this.displayingStandards.forEach(i => {
      if (i.viewed === true) {
        this.displayingStandardsViewed.unshift(i);
        this.displayingStandards = this.displayingStandards.filter(
          el => el.viewed === false
        );
      }
    });
    this.displayingSuggestions.forEach(i => {
      if (i.viewed === true) {
        this.displayingSuggestViewed.unshift(i);
        this.displayingSuggestions = this.displayingSuggestions.filter(
          el => el.viewed === false
        );
      }
    });

    this.sortedSuggestionsTable = [
      ...this.displayingSuggestions,
      ...this.displayingSuggestViewed
    ];
    this.isLoaded = true;
  }

  setDaysField(list) {
    list.forEach(item => {
      if (item.expiringDate !== "") {
        const expiringDateConst = moment(item.expiringDate).startOf("day");
        const currentDate = moment().startOf("day");
        item.days = expiringDateConst.diff(currentDate, "days");
      }
    });

    this.isLoaded = true;
  }

  setActiveList(i) {
    this.activeList = i;
    this.loadNotificationHistoryForActiveList();
  }

  loadSuggestionHistoryPage(page: number) {
    const uiPage = this.normalizeUiPage(page);

    this.suggestionHistoryPage = uiPage;
    this.suggestionHistoryLoading = true;
    this.operatingStandardService
      .getSuggestionNotificationsHistory(
        this.toBackendPage(uiPage),
        this.notificationHistoryPageSize,
        this.resolveViewedFilter()
      )
      .subscribe(
        (res: any) => {
          this.applySuggestionHistoryResponse(res ? res.body : null, uiPage);
          this.suggestionHistoryLoaded = true;
          this.suggestionHistoryLoading = false;
        },
        () => {
          this.suggestionHistoryLoaded = true;
          this.suggestionHistoryLoading = false;
          this.errorMessage = true;
          this.clearSuggestionHistory();
        }
      );
  }

  loadGeneralHistoryPage(page: number) {
    const uiPage = this.normalizeUiPage(page);

    this.generalHistoryPage = uiPage;
    this.generalHistoryLoading = true;
    this.operatingStandardService
      .getGeneralNotificationsHistory(
        this.toBackendPage(uiPage),
        this.notificationHistoryPageSize,
        this.resolveViewedFilter()
      )
      .subscribe(
        (res: any) => {
          this.applyGeneralHistoryResponse(res ? res.body : null, uiPage);
          this.generalHistoryLoaded = true;
          this.generalHistoryLoading = false;
        },
        () => {
          this.generalHistoryLoaded = true;
          this.generalHistoryLoading = false;
          this.errorMessage = true;
          this.clearGeneralHistory();
        }
      );
  }

  // OK
  // ADDED_SUGGESTION_FOR_REVIEW
  // SUGGESTION_CANCELLED
  // SUGGESTION_IMPLEMENTED
  // SUGGESTION_POSTPONED
  // SUGGESTION_REASSIGNED
  // SUGGESTION_POSTPONE_EXPIRED
  // ALL_SUGGESTION_TASKS_DONE
  // SUGGESTION_TASK_WORK
  // SUGGESTION_TASKS_EXPIRED
  openNotification(stnd, type = null) {
    if (this.isClothingNotification(stnd)) {
      this.handleClothingNotification(stnd, type);
      return;
    }
    let sID = "";
    let sType = "";
    let sStatus = "";
    let slID = "";
    const itemId = stnd.id;
    // Check Notification type
    switch (stnd.category) {
      case "GLOBAL":
        sID = stnd.standardId;
        sType = stnd.type;
        sStatus = stnd.status;
        slID = "";
        break;
      case "SUGGESTION":
        sID = "";
        sType = stnd.type;
        sStatus = stnd.status;
        slID = stnd.suggestionId;
        break;
      case "SUGGESTION_ACTION":
        // has result
        sID = "";
        sType = stnd.type;
        sStatus = stnd.status;
        slID = stnd.suggestionId;
        break;
      case "SUGGESTION_CANCEL":
        // has reason
        sID = "";
        sType = stnd.type;
        sStatus = stnd.status;
        slID = stnd.suggestionId;
        break;
    }

    if (type === "stnd") {
      const sendingParams = {
        id: itemId,
        notificationCategory: STANDARD_NOTIFICATION_CATEGORY
      };
      localStorage.setItem('notificationCategory', JSON.stringify(sendingParams));
      localStorage.setItem('standartType', stnd.type);
      this.adminService.notifyIsView(sendingParams).subscribe(
        (response: any) => { },
        () => {
          this.isLoaded = false;
        }
      );
    }
    if (type === "sl") {
      const sendingParams = {
        id: itemId,
        notificationCategory: SUGGESTION_NOTIFICATION_CATEGORY
      };
      this.adminService.notifyIsView(sendingParams).subscribe(
        (response: any) => {
          stnd.viewed = true;
        },
        () => {
          this.isLoaded = false;
        }
      );
    }
    if (type === "slsl") {
      const sendingParams = {
        id: itemId,
        notificationCategory: GENERAL_NOTIFICATION_CATEGORY
      };
      this.adminService.notifyIsView(sendingParams).subscribe(
        (response: any) => {
          this.loadGeneralHistoryPage(this.generalHistoryPage);
        },
        () => {
          this.isLoaded = false;
        }
      );
    }

    // смотреть на тип и перенаправлять куда нужно
    switch (sType) {
      case "CONFIRMATION_STARTED":
        this.router.navigate(["/dashboard/confirm-standard/" + sID]);
        break;
      case "MODIFY_REQUEST":
        this.stepsControllerService.setNotifyType("MODIFY_REQUEST");
        this.modifyActionDo(sID, true, "MODIFY_REQUEST", "STNDR");
        break;
      case "CONFIRMATION_FINISHED":
        this.stepsControllerService.setNotifyType("CONFIRMATION_FINISHED");
        this.modifyActionDo(sID, true, "CONFIRMATION_FINISHED", "STNDR");
        break;
      case "CONF_CHAT_MESSAGE":
        this.modifyActionDo(sID, true, "CONF_CHAT_MESSAGE", "STNDR");
        break;
      case "FAMILIARIZATION_STARTED":
        this.router.navigate(["/dashboard/familiarize-standard/" + sID]);
        break;
      case "FAMILIARIZATION_FINISHED":
        this.stepsControllerService.setNotifyType("FAMILIARIZATION_FINISHED");
        this.modifyActionDo(sID, true, "FAMILIARIZATION_FINISHED", "STNDR");
        break;
      case "MODIFICATION_DONE":
        this.router.navigate(["/dashboard/confirm-standard/" + sID]);
        break;
      case "TESTING_STARTED":
        this.router.navigate(["/dashboard/familiarize-standard/" + sID]);
        break;
      case "TRANSLATED_MAIN_INFO_DONE":
        this.stepsControllerService.setNotifyType("CONFIRMATION_FINISHED");
        this.modifyActionDo(sID, true, "CONFIRMATION_FINISHED", "STNDR");
        break;
      case "TRANSLATION_COMPLETED":
        this.stepsControllerService.setNotifyType("FAMILIARIZATION_FINISHED");
        this.modifyActionDo(sID, true, "FAMILIARIZATION_FINISHED", "STNDR");
        break;
      case "ADDED_SUGGESTION_FOR_REVIEW":
        this.modifyActionDo(slID, true, "ADDED_SUGGESTION_FOR_REVIEW", "SL");
        break;
      case "SUGGESTION_CANCELLED":
        this.modifyActionDo(slID, true, "SUGGESTION_CANCELLED", "SL");
        break;
      case "SUGGESTION_APPROVE_CANCELLED":
        this.modifyActionDo(slID, true, "SUGGESTION APPROVE CANCELLED", "SL");
        break;
      case "SUGGESTION_IMPLEMENTED":
        this.modifyActionDo(slID, true, "SUGGESTION_IMPLEMENTED", "SL");
        break;
      case "SUGGESTION_POSTPONED":
        this.modifyActionDo(slID, true, "SUGGESTION_POSTPONED", "SL");
        break;
      case "SUGGESTION_REASSIGNED":
        this.modifyActionDo(slID, true, "SUGGESTION_REASSIGNED", "SL");
        break;
      case "SUGGESTION_POSTPONE_EXPIRED":
        this.modifyActionDo(slID, true, "SUGGESTION_POSTPONE_EXPIRED", "SL");
        break;
      case "ALL_SUGGESTION_TASKS_DONE":
        this.modifyActionDo(slID, true, "ALL_SUGGESTION_TASKS_DONE", "SL");
        break;
      case "SUGGESTION_TASK_WORK":
        this.modifyActionDo(slID, true, "SUGGESTION_TASK_WORK", "SL");
        break;
      case "SUGGESTION_TASKS_EXPIRED":
        this.modifyActionDo(slID, true, "SUGGESTION_TASK_WORK", "SL");
        break;
      case "NEW_MESSAGE":
        this.modifyActionDo(slID, true, "NEW_MESSAGE", "SL");
        break;
    }
  }

  modifyActionDo(sID, toSteps, status, objectTxt) {
    // IF STANDARD
    if (objectTxt === "STNDR") {
      this.adminService.getStandard(sID).subscribe(
        (response: any) => {
          this.errorMessage = false;
          if (response.status === 200) {
            const standard = response.body;

            if (status === "CONF_CHAT_MESSAGE") {
              this.router.navigate(["/dashboard/confirm-standard/" + sID]);
            } else {
              if (this.userService.getLocal().id === standard.author.id) {
                if (toSteps) {
                  this.stepsControllerService.setCurrentStandard(standard);
                }
              } else {
                this.router.navigate(["/dashboard/confirm-standard/" + sID]);
              }
            }
          }
        },
        () => {
          this.errorMessage = true;
        }
      );
    } else if (objectTxt === "SL") {
      // IF SL
      this.router.navigate(["/dashboard/suggestion-list-details/" + sID]);
    }
  }

  // OK
  // ADDED_SUGGESTION_FOR_REVIEW
  // SUGGESTION_CANCELLED
  // SUGGESTION_IMPLEMENTED
  // SUGGESTION_POSTPONED
  // SUGGESTION_REASSIGNED
  // SUGGESTION_POSTPONE_EXPIRED
  // ALL_SUGGESTION_TASKS_DONE
  // SUGGESTION_TASK_WORK
  // SUGGESTION_TASKS_EXPIRED
  setClass(type, status) {
    if (status === "ACTIVE") {
      switch (type) {
        case "CONFIRMATION_STARTED":
          return "notify-border-left-one";
        case "MODIFY_REQUEST":
          return "notify-border-left-two";
        case "CONFIRMATION_FINISHED":
          return "notify-border-left-three";
        case "CONF_CHAT_MESSAGE":
          return "notify-border-left-four";
        case "FAMILIARIZATION_STARTED":
          return "notify-border-left-five";
        case "FAMILIARIZATION_FINISHED":
          return "notify-border-left-six";
        case "MODIFICATION_DONE":
          return "notify-border-left-md";
        case "TESTING_STARTED":
          return "notify-border-left-ts";
        case "TRANSLATED_MAIN_INFO_DONE":
        case "TRANSLATION_COMPLETED":
          return "notify-border-left-translate";
        case "ADDED_SUGGESTION_FOR_REVIEW":
        case "SUGGESTION_CANCELLED":
        case "SUGGESTION_IMPLEMENTED":
        case "SUGGESTION_POSTPONED":
        case "SUGGESTION_REASSIGNED":
        case "SUGGESTION_POSTPONE_EXPIRED":
        case "ALL_SUGGESTION_TASKS_DONE":
        case "SUGGESTION_TASK_WORK":
        case "SUGGESTION_TASKS_EXPIRED":
          return "notify-border-left-sl";
      }
    } else {
      return "notify-border-left-sl";
    }
  }

  private hasNotificationItems(): boolean {
    return !!this.requiredActionList.length;
  }

  private handleClothingNotification(notification: AppNotification, type: string): void {
    if (this.isViewedClothingNotification(notification)) {
      return;
    }
    if (type === "clothing") {
      this.openClothingListNotification(notification);
      return;
    }
    this.openClothingNotification(notification);
  }

  private openClothingListNotification(notification: AppNotification): void {
    this.clothingNotificationActionService.openNotification(notification).then((success) => {
      if (!success) {
        return;
      }
      this.markClothingNotification(notification);
      notification.viewed = true;
      this.updateClothingNotifications();
    });
  }

  private markClothingNotification(notification: AppNotification): void {
    const sendingParams = {
      id: notification.id,
      notificationCategory: this.clothingNotificationRoutingService.resolveViewCategory(notification)
    };
    this.adminService.notifyIsView(sendingParams).subscribe(
      () => null,
      () => this.isLoaded = false
    );
  }

  private openClothingNotification(notification: AppNotification): void {
    this.clothingNotificationActionService.openNotification(notification);
  }

  private updateClothingNotifications(): void {
    this.displayingClothingNotifications = this.clothingNotifications.filter(
      notification => !notification.viewed || this.show
    );
  }

  private processGeneralNotifications(notifications: AppNotification[]): void {
    var generalNotifications = notifications ? notifications.slice() : [];

    generalNotifications.forEach(notification => this.prepareGeneralNotification(notification));
    this.allGeneralNotifications = generalNotifications;
    this.clothingNotifications = this.extractClothingNotifications(generalNotifications);
    if (!this.generalHistoryLoaded && !this.generalHistoryLoading) {
      this.generalNotify = [];
      this.karma = false;
    }
    this.updateClothingNotifications();
    this.activatePreferredNotificationList();
  }

  private activatePreferredNotificationList(): void {
    if (!this.isStorekeeperMobileFlow()) {
      return;
    }
    this.setPreferredActiveList();
  }

  private handleViewportResize(): void {
    if (!this.isLoaded) {
      return;
    }
    this.activatePreferredNotificationList();
  }

  private prepareGeneralNotification(notification: AppNotification): void {
    if (notification && notification.create) {
      notification.create = notification.create.split('T')[0];
    }
    if (this.isClothingNotification(notification)) {
      return;
    }
    if (!notification || !notification.description) {
      return;
    }
    if (~notification.description.indexOf('http')) {
      notification.link = ('http' + notification.description.split("http")[1]).toString();
      notification.description = notification.description.split("http")[0];
    }
  }

  private extractClothingNotifications(notifications: AppNotification[]): AppNotification[] {
    return notifications.filter(notification => this.isClothingNotification(notification));
  }

  private extractGeneralNotifications(notifications: AppNotification[]): AppNotification[] {
    return notifications.filter(notification => !this.isClothingNotification(notification));
  }

  private hasKarmaNotifications(notifications: any[]): boolean {
    return notifications.some(notification => !!notification.karmaId);
  }

  private hasStorekeeperRole(user: User): boolean {
    if (!user || !user.roles) {
      return false;
    }
    return user.roles.indexOf('ROLE_STOREKEEPER') !== -1
      || user.roles.indexOf('STOREKEEPER') !== -1;
  }

  private setPreferredActiveList(): void {
    if (!this.isStorekeeperMobileFlow()) {
      return;
    }
    this.activeList = CLOTHING_NOTIFICATION_LIST_INDEX;
  }

  private filterViewedNotifications<T extends { viewed?: boolean }>(items: T[]): T[] {
    if (!items || !items.length) {
      return [];
    }
    if (this.show) {
      return items;
    }
    return items.filter(item => !item.viewed);
  }

  private loadNotificationHistoryForActiveList(): void {
    if (this.activeList === SUGGESTION_NOTIFICATION_LIST_INDEX) {
      this.loadSuggestionHistoryPage(1);
    }
    if (this.activeList === GENERAL_NOTIFICATION_LIST_INDEX) {
      this.loadGeneralHistoryPage(1);
    }
  }

  private reloadActiveNotificationHistory(): void {
    if (this.activeList === SUGGESTION_NOTIFICATION_LIST_INDEX) {
      this.loadSuggestionHistoryPage(1);
    }
    if (this.activeList === GENERAL_NOTIFICATION_LIST_INDEX) {
      this.loadGeneralHistoryPage(1);
    }
  }

  private applySuggestionHistoryResponse(pageBody: any, fallbackPage: number): void {
    const content = this.getPageContent(pageBody)
      .map(notification => this.prepareSuggestionHistoryNotification(notification));

    this.suggestionLists = content;
    this.displayingSuggestions = content.filter(notification => !notification.viewed);
    this.displayingSuggestViewed = content.filter(notification => !!notification.viewed);
    this.sortedSuggestionsTable = content;
    this.suggestionHistoryTotalItems = this.resolveTotalItems(pageBody, content.length);
    this.suggestionHistoryPage = this.resolveUiPage(pageBody, fallbackPage);
  }

  private applyGeneralHistoryResponse(pageBody: any, fallbackPage: number): void {
    const content = this.getPageContent(pageBody)
      .map(notification => this.prepareGeneralHistoryNotification(notification))
      .filter(notification => !this.isClothingNotification(notification));

    this.generalNotify = content;
    this.karma = this.hasKarmaNotifications(this.generalNotify);
    this.generalHistoryTotalItems = this.resolveTotalItems(pageBody, content.length);
    this.generalHistoryPage = this.resolveUiPage(pageBody, fallbackPage);
  }

  private clearSuggestionHistory(): void {
    this.suggestionLists = [];
    this.displayingSuggestions = [];
    this.displayingSuggestViewed = [];
    this.sortedSuggestionsTable = [];
    this.suggestionHistoryTotalItems = 0;
  }

  private clearGeneralHistory(): void {
    this.generalNotify = [];
    this.karma = false;
    this.generalHistoryTotalItems = 0;
  }

  private prepareSuggestionHistoryNotification(notification: any): any {
    const item = Object.assign({}, notification || {});

    if (!item.category) {
      item.category = SUGGESTION_NOTIFICATION_CATEGORY;
    }
    if (!item.description) {
      item.description = "";
    }
    if (!item.initiator && item.source && item.source.fullName) {
      item.initiator = item.source.fullName;
    }
    if (!item.initiatorNativeName && item.source && item.source.fullNativeName) {
      item.initiatorNativeName = item.source.fullNativeName;
    }
    if (!item.initiator) {
      item.initiator = "";
    }

    return item;
  }

  private prepareGeneralHistoryNotification(notification: any): AppNotification {
    const item = Object.assign({}, notification || {});

    if (!item.description) {
      item.description = "";
    }
    this.prepareGeneralNotification(item);

    return item;
  }

  private getPageContent(pageBody: any): any[] {
    if (!pageBody || !Array.isArray(pageBody.content)) {
      return [];
    }
    return pageBody.content;
  }

  private resolveTotalItems(pageBody: any, fallbackTotal: number): number {
    if (!pageBody || pageBody.totalElements === undefined || pageBody.totalElements === null) {
      return fallbackTotal;
    }
    return Number(pageBody.totalElements);
  }

  private resolveUiPage(pageBody: any, fallbackPage: number): number {
    if (!pageBody || pageBody.currentPage === undefined || pageBody.currentPage === null) {
      return fallbackPage;
    }
    return Number(pageBody.currentPage) + 1;
  }

  private normalizeUiPage(page: number): number {
    const normalizedPage = Number(page);

    if (!normalizedPage || normalizedPage < 1) {
      return 1;
    }
    return normalizedPage;
  }

  private toBackendPage(page: number): number {
    return this.normalizeUiPage(page) - 1;
  }

  private resolveViewedFilter(): any {
    return this.show ? null : false;
  }

  private getSuggestionInitiator(notification: any): string {
    if (!notification) {
      return "";
    }
    if (notification.initiator) {
      return notification.initiator;
    }
    if (notification.source && notification.source.fullName) {
      return notification.source.fullName;
    }
    return "";
  }

  private getNotificationSortDate(notification: any): string {
    if (!notification) {
      return "";
    }
    return (notification.timestamp || notification.create || "").toString();
  }

  private getNotificationSortStatus(notification: any): string {
    if (!notification) {
      return "";
    }
    return (notification.suggestionStatus || notification.type || "").toString();
  }

  changeSortDirection(table, field) {
    if (!table || !table.sort) {
      return;
    }

    this.sortOrder =
      this.sortOrder === "descending" ? "ascending" : "descending";

    switch (field) {
      case "initiator":
        if (this.sortOrder === "descending") {
          table.sort((a, b) =>
            this.getSuggestionInitiator(a).localeCompare(this.getSuggestionInitiator(b))
          );
        } else if (this.sortOrder === "ascending") {
          table.sort((a, b) =>
            this.getSuggestionInitiator(b).localeCompare(this.getSuggestionInitiator(a))
          );
        }

        break;

      case "date":
        if (this.sortOrder === "descending") {
          table.sort((a, b) =>
            this.getNotificationSortDate(a).localeCompare(this.getNotificationSortDate(b))
          );
        } else if (this.sortOrder === "ascending") {
          table.sort((a, b) =>
            this.getNotificationSortDate(b).localeCompare(this.getNotificationSortDate(a))
          );
        }
        break;

      case "status":
        if (this.sortOrder === "descending") {
          table.sort((a, b) => this.getNotificationSortStatus(a).localeCompare(this.getNotificationSortStatus(b)));
        } else if (this.sortOrder === "ascending") {
          table.sort((a, b) => this.getNotificationSortStatus(b).localeCompare(this.getNotificationSortStatus(a)));
        }
        break;
    }
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/operating-standard/operating-standard.component.ts